const formatarValor = (valor) => {
  return valor
    ? valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
    : "";
};

const formatarData = (data) => {
  if (!data) return ""; // Retorna vazio se data for null ou undefined
  const dataObj = new Date(data);
  const dia = dataObj.getDate().toString().padStart(2, "0");
  const mes = (dataObj.getMonth() + 1).toString().padStart(2, "0");
  const ano = dataObj.getFullYear().toString().substring(2);
  const hora = dataObj.getHours().toString().padStart(2, "0");
  const minutos = dataObj.getMinutes().toString().padStart(2, "0");
  // const segundos = dataObj.getSeconds().toString().padStart(2, "0");
  return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
};

export { formatarData, formatarValor };
